"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardBucket = CardBucket;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _admin = require("../../../reducers/admin");
var _FormTimepoint = _interopRequireDefault(require("./FormTimepoint"));
var _style = _interopRequireDefault(require("./style.css"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// TODO: move roles/respondents logic into the component
var roles = window.cccisd.appDefs.pawn.roles;
var nonManagedRoles = ['metricspawn', 'questprojectadmin', 'respondent', 'uberadmin'];
var respondents = roles.filter(function (role) {
  return !nonManagedRoles.includes(role.handle);
}).map(function (role) {
  return {
    label: role.label,
    value: role.handle
  };
});
var initialValues = {
  respondent: '',
  roleHandle: respondents.length ? respondents[0].value : '',
  timepoints: []
};
var timepointInitialValues = {
  surveys: []
};
function CardBucket(_ref) {
  var droppableId = _ref.droppableId,
    type = _ref.type,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: droppableId,
    type: type
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), children, provided.placeholder);
  });
}
function OutcomesDataEntry(_ref2) {
  var assignmentData = _ref2.assignmentData,
    closeModal = _ref2.closeModal;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    timepoints = _useState2[0],
    setTimepoints = _useState2[1];
  var existingConfig = _objectSpread(_objectSpread({}, initialValues), assignmentData.settings.navigationSettings);
  (0, _react.useEffect)(function () {
    if (assignmentData.settings.navigationSettings.timepoints === undefined) {
      setTimepoints([]);
    } else {
      setTimepoints(assignmentData.settings.navigationSettings.timepoints);
    }
  }, []);
  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }
  function _onSubmit() {
    _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(values) {
      var createHandle, createHash, batchToCreate, batchToUpdate, batchToRemove, _t;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            createHash = function _createHash() {
              return Math.random().toString(36).substring(2, 9);
            };
            createHandle = function _createHandle(label, hash) {
              return "".concat(label.toLowerCase().trim().replace(' ', '_'), "_").concat(hash);
            };
            values.timepoints = values.timepoints.map(function (timepoint) {
              if (timepoint.hash) {
                return _objectSpread({}, timepoint);
              }
              var hash = createHash();
              return _objectSpread(_objectSpread({}, timepoint), {}, {
                hash: hash,
                handle: createHandle(timepoint.label, hash)
              });
            });
            if ((0, _isEqual2["default"])(existingConfig, values)) {
              _context4.n = 4;
              break;
            }
            // identify which timepoints are new
            batchToCreate = values.timepoints.filter(function (timepoint) {
              return !existingConfig.timepoints.map(function (t) {
                return t.hash;
              }).includes(timepoint.hash);
            }); // identify which sessions need to be updated
            batchToUpdate = values.timepoints.filter(function (timepoint) {
              return existingConfig.timepoints.map(function (t) {
                return t.hash;
              }).includes(timepoint.hash);
            }).filter(function (timepoint) {
              return !(0, _isEqual2["default"])(timepoint, existingConfig.timepoints.find(function (t) {
                return t.hash === timepoint.hash;
              }));
            }); // identify which sessions need to be removed
            batchToRemove = existingConfig.timepoints.filter(function (timepoint) {
              return !values.timepoints.map(function (t) {
                return t.hash;
              }).includes(timepoint.hash);
            });
            batchToCreate.forEach(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref5) {
                var hash, handle, label, surveys, isCreateSuccess;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      hash = _ref5.hash, handle = _ref5.handle, label = _ref5.label, surveys = _ref5.surveys;
                      _context.n = 1;
                      return dispatch((0, _admin.createWave)(assignmentData.assignmentId, {
                        type: 'group',
                        roleHandle: values.roleHandle,
                        hash: hash,
                        label: label,
                        handle: handle,
                        isOpen: true,
                        settings: {
                          respondentConfig: 'managed',
                          respondentSelection: values.roleHandle,
                          options: Object.keys(surveys),
                          allowRetake: true,
                          chainEmailFromPawn: null,
                          chainPhoneFromPawn: null,
                          closedRoster: false,
                          completedMessage: 'You have already completed this survey. Thank you!',
                          completionMessage: 'You have completed the survey! Thank you for your response!',
                          completionUrl: null,
                          logoutOnCompletion: false
                        }
                      }));
                    case 1:
                      isCreateSuccess = _context.v;
                      if (!isCreateSuccess) {
                        (0, _cccisdNotification["default"])({
                          type: 'danger',
                          message: "Quest failed to update"
                        });
                      }
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref6.apply(this, arguments);
              };
            }());
            batchToUpdate.forEach(/*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref7) {
                var hash, handle, label, surveys, _assignmentData$deplo, deploymentId, settings, isUpdateSuccess;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      hash = _ref7.hash, handle = _ref7.handle, label = _ref7.label, surveys = _ref7.surveys;
                      _assignmentData$deplo = assignmentData.deploymentList.find(function (deployment) {
                        return hash === deployment.hash;
                      }), deploymentId = _assignmentData$deplo.deploymentId, settings = _assignmentData$deplo.settings;
                      _context2.n = 1;
                      return dispatch((0, _admin.updateWave)(deploymentId, {
                        label: label,
                        handle: handle,
                        settings: _objectSpread(_objectSpread({}, settings), {}, {
                          options: Object.keys(surveys)
                        })
                      }));
                    case 1:
                      isUpdateSuccess = _context2.v;
                      if (!isUpdateSuccess) {
                        (0, _cccisdNotification["default"])({
                          type: 'danger',
                          message: "Quest failed to update"
                        });
                      }
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              return function (_x3) {
                return _ref8.apply(this, arguments);
              };
            }());
            batchToRemove.forEach(/*#__PURE__*/function () {
              var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref9) {
                var hash, _assignmentData$deplo2, deploymentId;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      hash = _ref9.hash;
                      _assignmentData$deplo2 = assignmentData.deploymentList.find(function (deployment) {
                        return hash === deployment.hash;
                      }), deploymentId = _assignmentData$deplo2.deploymentId;
                      _context3.n = 1;
                      return dispatch((0, _admin.removeWave)(deploymentId));
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              return function (_x4) {
                return _ref0.apply(this, arguments);
              };
            }());
            _context4.p = 1;
            _context4.n = 2;
            return dispatch((0, _admin.updateQuest)(assignmentData.assignmentId, _objectSpread(_objectSpread({
              title: "Outcomes Data Entry - ".concat(values.respondent),
              subtitle: 'Quest for Outcomes Data Entry Page Configuration',
              handle: "outcomes_data_".concat(assignmentData.assignmentId)
            }, assignmentData.settings), {}, {
              navigationSettings: _objectSpread(_objectSpread({}, existingConfig), values)
            })));
          case 2:
            (0, _cccisdNotification["default"])("Quest successfully updated");
            closeModal();
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t = _context4.v;
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: "Quest failed to update"
            });
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _onSubmit.apply(this, arguments);
  }
  function _onDragEnd(result, swap) {
    if (result.type !== 'TIMEPOINTS' || !result.destination || result.destination.index === result.source.index) {
      return;
    }
    swap(result.destination.index, result.source.index);
  }
  function RespondentField() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].respondentField
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Respondent",
        tooltip: "The name of the respondent. This will appear on the tab on the Outcomes Data Page."
      }),
      name: "respondent",
      component: _cccisdFormik.CccisdInput
    }));
  }
  function RoleField() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].roleField
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      className: _style["default"].field,
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Role",
        tooltip: "The role to save responses against."
      }),
      name: "roleHandle",
      component: _cccisdFormik.CccisdSelect,
      options: respondents
    }));
  }
  function ProviderToggle() {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
        label: "Is respondent a provider?",
        tooltip: "Will the respondent also be the logged-in user? If so, this setting will disable messaging."
      }),
      name: "isProvider",
      component: _cccisdFormik.CccisdToggle
    });
  }
  return timepoints && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: onSubmit,
    initialValues: _objectSpread({}, existingConfig)
  }, function (_ref3) {
    var values = _ref3.values,
      isSubmitting = _ref3.isSubmitting,
      submitForm = _ref3.submitForm;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/_react["default"].createElement(RespondentField, null), /*#__PURE__*/_react["default"].createElement(RoleField, null)), /*#__PURE__*/_react["default"].createElement(ProviderToggle, null), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
      name: "timepoints"
    }, function (_ref4) {
      var push = _ref4.push,
        remove = _ref4.remove,
        swap = _ref4.swap,
        form = _ref4.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        form: form,
        field: {
          name: 'timepoints'
        },
        label: "Timepoints"
      }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: function onDragEnd(result) {
          return _onDragEnd(result, swap);
        }
      }, /*#__PURE__*/_react["default"].createElement(CardBucket, {
        droppableId: "droppable_timepoints",
        type: "TIMEPOINTS"
      }, values.timepoints.map(function (value, i) {
        return /*#__PURE__*/_react["default"].createElement(_FormTimepoint["default"], {
          timepoint: value,
          key: i,
          surveyList: assignmentData.currentSurveylistList.surveyList,
          timepoints: assignmentData.settings.navigationSettings.timepoints,
          timepointNumber: i + 1,
          removeTimepoint: function removeTimepoint() {
            return remove(i);
          },
          respondents: respondents
        });
      }))), /*#__PURE__*/_react["default"].createElement("button", {
        className: _style["default"].addCardButton,
        type: "button",
        onClick: function onClick() {
          return push(timepointInitialValues);
        }
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
        spaceRight: true
      }), "Add Timepoint"));
    }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-primary",
      isLoading: isSubmitting,
      isDisabled: isSubmitting || (0, _isEqual2["default"])(existingConfig, values),
      onClick: function onClick() {
        return submitForm();
      }
    })));
  });
}
var _default = exports["default"] = OutcomesDataEntry;